import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from "primeng/components/common/messageservice";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
declare var gapi: any
import { addgradetolevelModel } from "../../../../../components/dataAnalytics/dataAnalytics.model";


@Component({
  selector: 'addgradetolevelH',
  templateUrl: 'addgradetolevelH.component.html',
  styleUrls: ['addgradetolevelH.component.scss'],

})
export class AddgradetolevelHComponent implements OnInit {
  display = "none";
  display1 = "none"
  public level: any;



  public ShowLevelData: any;
  public gradenameupdate: string = '';
  public selectedlevel: string = '';
  public selectedleveladd: string = '';
  collection = 0;



  public levelIdUpdate: string = '';

  public yearnameupdate: string = '';
  public selectedYear: string = '';
  public addGradeSA: boolean = false;


  public schoolId: any;
  public userId :string;
  processedData: any;

  mappedData: any[] = [];
  gradeData: any[] = [];

  constructor(private dataAnalyticsService: DataAnalyticsService, private messageService: MessageService,
              private noticeboardService: NoticeboardService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService,
  ) {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    this.userId = this.localStorage.retrieve('id');
  }



  ngOnInit() {
    this.getLevelsName();
  }

  private addGrade() {

    const selectedSections: number[] = this.gradeData
      .filter(std => std.checkFlag)
      .map(std => std.Sections.map(section => section.SectionId))
      .reduce((acc, curr) => acc.concat(curr), [] as number[]);

    console.log(selectedSections);

    const sectionidlist = selectedSections.map(sectionId => ({ sectionid: sectionId }));
    console.log({ sectionidlist });

    const payload = {
      Levelid: this.selectedlevel,
      sectionidlist: sectionidlist,
      status: "Pending"
    };

    console.log("postGradeLevel", payload);

    this.dataAnalyticsService
      .postGradeLevel(payload)
      .finally(() => { })
      .subscribe(
        response => {
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Grade to Level Added Successfully",
          });
          this.gradeData = [];
          this.getLevelsName();
          // this.Addlevel();
          console.log(response);
        },
        error => {
          console.error('Error occurred:', error);
        }
      );
    this.getLevelsName();
    this.display= "none"

  }

  private addGradeSelectAll(){
    if(this.addGradeSA)
      this.gradeData.map(e => {
        if(!e.checkFlag2)
          e.checkFlag = true;
      });
    else
      this.gradeData.map(e => {
        if(!e.checkFlag2)
          e.checkFlag = false;
      });
  }


  private GetLevelStandardSectionMapping(){
    this.dataAnalyticsService.getGradeLevel(this.selectedlevel).finally(() => { }).subscribe(
      response => {
        this.level = response;
        this.level.forEach(levelItem => {
          levelItem.Sections.sort((a, b) => {
            return a.sectionName.localeCompare(b.sectionName);
          });
        });

        console.log('levels', this.level);

        this.collection = this.level.length;
        console.log('levels',this.level);
        this.getClassSectionMap();
      },
      error => {
        this.level = [];
        console.error(error);
        console.log('levels',this.level)
      });
  };


  private getClassSectionMap() {
    this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        // console.log('getClassSectionMap', response);
        this.mappedData = response as any;
        this.mappedData.map(e => {
          e.checkFlag = this.level.find(f => f.standardId == e.standardId) ? true : false
          e.checkFlag2 = this.level.find(f => f.standardId == e.standardId) ? true : false
        });
        // console.log(this.mappedData);
      },
      error => {
        console.error(error);
      }
    );
  }

//----------------------------------------------Get------------------------------------------------
  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        try {
          this.selectedlevel =  this.ShowLevelData[0].Id;
          this.GetLevelStandardSectionMapping()
          //this.getClassSectionMap();
        } catch (error) {

        }
        console.log("ShowLevelData", this.ShowLevelData);
      });
  }

  changeLevel(selectedlevel) {
    console.log("selectedlevel",selectedlevel)
    this.GetLevelStandardSectionMapping();
    //this.getClassSectionMap();
  };

  changeLeveladd(selectedleveladd) {
    console.log("selectedleveladd",selectedleveladd)
    this.Addlevel();
    //this.getClassSectionMap();
  };

//----------------------------------------------Post------------------------------------------------

// postGradeLevel() {
//   var payload = {
//     Levelid: this.selectedlevel,
//     //sectionid:this.schoolId
//   };

//   console.log("postGradeLevel",payload);

//   this.dataAnalyticsService
//     .postAcadamicYear(payload)
//     .finally(() => {})
//     .subscribe(
//       (response) => {
//         this.messageService.add({
//           severity: "success",
//           summary: "Talkative Parents",
//           detail: "Academic Year Added Successfully",
//         });
//         this.display = "none";
//         this.GetLevelStandardSectionMapping();

//         console.log(response);
//       },
//       (error) => {}
//     );
// }


//----------------------------------------------Update------------------------------------------------
  updateGradeLevel() {
    var payload = {
      Id: this.levelIdUpdate,
      Name: this.gradenameupdate,

    };

    console.log("updateGradeLevel",payload);

    this.dataAnalyticsService
      .updateGradeLevel(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Add grade to level Update Successfully",
          });
          this.display1 = "none";
          this.getLevelsName();

          console.log(response);
        },
        (error) => {}
      );
  }


  Addlevel() {
    this.dataAnalyticsService.getGrades().finally(() => { }).subscribe(
      response => {
        const data = response as any;
        this.gradeData = data.Value;
        console.log(this.gradeData);
        // console.log('getGrades', response);
        // const data = response as any;
        // this.mappedData = data.Value;
        // console.log(this.mappedData);
        // this.mappedData.map(e => {
        //   e.checkFlag = this.level.find(f => f.standardId == e.standardId) ? true : false
        //   e.checkFlag2 = this.level.find(f => f.standardId == e.standardId) ? true : false
        // });
        // console.log(this.mappedData);
      },
      error => {
        console.error(error);
      }
    );
    this.display= "block"
  }

  editlevel(level: any) {
    this.gradenameupdate = level.standardsName;
    this.levelIdUpdate = level.standardId;
    this.display1= "block"
    //this.selectedlevel = level;

  }

  onCloseHandled() {
    this.display = "none";
    this.display1 = "none";
  }
  confirm(Id) {
    console.log(Id)
    // this.DeleteSubjects(Id);
    this.confirmationService.confirm({
      message: 'Are you sure that you want to perform this action?',
      accept: () => {
        //  this.DeleteAcdemicYears(Id);
      }
    });
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/AddGradeToLevel/addgradetolevelH.component.ts